module.exports = __webpack_public_path__ + "img/target_retirement.978fdb37.svg";